import { Ship, Users, Wallet } from 'lucide-react'
import React, { useEffect, useState } from 'react'

import AnkorLogo from '@/assets/AnkorLogo.svg'
import { Heading } from '@/ui-components/Heading'
import { Text } from '@/ui-components/Text'

let interval: NodeJS.Timeout
export const LeftSideFeatures = () => {
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0)
  const features = [
    {
      icon: Wallet,
      title: 'Finance Overview',
      description: 'Track balances across multiple currencies and manage vessel finances.',
    },
    {
      icon: Ship,
      title: 'Vessels',
      description: 'Organize expenses and budgets by individual vessels for better financial oversight.',
    },
    {
      icon: Users,
      title: 'Team Management',
      description: 'Issue cards and manage crew member spending permissions across your fleet.',
    },
  ]

  useEffect(() => {
    interval = setInterval(() => {
      setCurrentFeatureIndex((prev) => (prev + 1) % features.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [features.length])

  const updateCarouselState = (index: number) => {
    setCurrentFeatureIndex(index)
    clearInterval(interval)
    interval = setInterval(() => {
      setCurrentFeatureIndex((prev) => (prev + 1) % features.length)
    }, 4000)
  }

  return (
    <div className="flex-1 flex flex-col justify-around lg:justify-between items-center lg:items-start p-4 sm:p-6 md:p-8 lg:p-16 order-1 bg-primary-100 dark:bg-primary-900">
      {/* Header */}
      <div className="flex items-center gap-x-4 select-none">
        <img
          src={AnkorLogo}
          alt="AnkorPay"
          className="size-8 dark:invert"
        />
        <Heading level={1}>AnkorPay</Heading>
      </div>

      {/* Current Feature */}
      <div className="space-y-4 sm:space-y-6 lg:space-y-8 max-w-sm lg:max-w-md mx-auto lg:mx-0">
        <div className="flex items-center justify-center lg:justify-start space-x-3 sm:space-x-4 py-0 px-0 my-0">
          <div className="size-10 sm:size-12 rounded-lg flex items-center justify-center bg-primary-700 dark:bg-primary-500">
            {React.createElement(features[currentFeatureIndex].icon, {
              className: 'size-5 sm:size-6 text-white',
            })}
          </div>
          <div>
            <Heading level={2}>{features[currentFeatureIndex].title}</Heading>
          </div>
        </div>

        <Text className="mt-2 text-center lg:text-left">{features[currentFeatureIndex].description}</Text>

        {/* Carousel Indicators */}
        <div className="flex justify-center lg:justify-start space-x-2">
          {features.map((_, index) => (
            <button
              key={index}
              className={`cursor-pointer size-2 rounded-full transition-colors duration-300 ${index === currentFeatureIndex ? 'bg-gray-900 dark:bg-white' : 'bg-gray-300 dark:bg-gray-900'}`}
              onClick={() => updateCarouselState(index)}
            />
          ))}
        </div>
      </div>

      {/* Bottom spacer - hidden on mobile */}
      <div className="hidden lg:block" />
    </div>
  )
}

export default LeftSideFeatures
